import React, { useState } from 'react';
import Text from 'components/Text';
import {Formik} from 'formik';
import { Button } from 'components/Button';
import bem from 'utils/bem';
import Loader from 'components/Loader';
import Model from '../../../../model';
import PasswordField from 'forms/fields/PasswordField';
import { passwordValidationSchema } from 'forms/forms/ChangePasswordForm/validationSchema';
import './index.sass'
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router';

const { block, el } = bem('change-password-form', 'form');

const defaultValues = {
    newPassword: '',
    newPasswordConfirmation: ''
};

const ChangePasswordForm = () => {

    const { updateUserPassword } = Model.user;
    const { closeChangePasswordForm } = Model.modal;

    const handleSubmit = (values, form) => {
        updateUserPassword(values.newPassword).then((response) => {
            if (response.userId) {
                closeChangePasswordForm();
                toast.success('Пароль был успешно изменён');
                window.location.href = '/';
            } else {
                console.error(response);
                form.resetForm();
                toast.error('Произошла ошибка; пожалуйста, обратитесь к администратору');
            }
        });
    };

    const rForm = (form) => {
        return (
            <form className={block()} onSubmit={form.handleSubmit}>
                <div className={el('title')}>
                    <Text serif>Смена пароля</Text>
                </div>
                <div className={el('fields')}>
                    <div className={el('password')}>
                        <PasswordField name={'newPassword'} placeholder={'Новый пароль'} />
                    </div>
                    <div className={el('password-confirmation')}>
                        <PasswordField name={'newPasswordConfirmation'} placeholder={'Подтвердите пароль'} />
                    </div>
                </div>
                <div className={el('buttons')}>
                    <Button mod={'gold'}
                            type='submit'
                            disabled={form.isSubmitting}>
                        Сохранить
                    </Button>
                </div>
            </form>
        )
    }

    return (
        <Formik
            initialValues={defaultValues}
            onSubmit={handleSubmit}
            isInitialValid={false}
            validateOnChange={false}
            validationSchema={passwordValidationSchema}
            validateOnBlur={false}>
            {(form) => rForm(form)}
        </Formik>
    )
};

export default ChangePasswordForm;
